/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */
/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

export const contentTypeSelector = (type: string) => `[data-section-type="${type}"]`;
export const componentSelector = (component: string) => `[data-component="${component}"]`;
export const configSelector = (component: string) => `[data-config="${component}"]`;
export const templateSelector = (template: string) => `[data-template="${template}"]`;

/**
 * Retrieve template element
 */
export function getTemplate(templateName: string, context?: HTMLElement): HTMLTemplateElement | null {
    return (context || document).querySelector(templateSelector(templateName));
}

/**
 * Retrieve template element children
 */
export function getTemplateChildren(templateName: string, context?: HTMLElement): HTMLElement[];
export function getTemplateChildren(template: HTMLTemplateElement): HTMLElement[];
export function getTemplateChildren(templateName: string | HTMLTemplateElement, context?: HTMLElement): HTMLElement[] {
    const template = typeof templateName === 'string' ? getTemplate(templateName, context) : templateName;

    if (template) {
        return Array.from((template.content.cloneNode(true) as DocumentFragment).children) as HTMLElement[];
    }

    return [];
}

/**
 * Retrieve single component element
 */
export function getComponentElement<T extends HTMLElement>(component: string, context?: HTMLElement): T | null {
    return (context || document).querySelector<T>(componentSelector(component));
}

/**
 * Retrieve component elements
 */
export function getComponentElements<T extends HTMLElement>(component: string, context?: HTMLElement): T[] {
    return Array.from(
        (context || document).querySelectorAll<T>(componentSelector(component))
    );
}

/**
 * Retrieve component configuration data
 */
export function getComponentConfig<T = object>(component: string, context?: HTMLElement): T {
    const configElements = (context || document).querySelectorAll(configSelector(component));
    let config = {} as T;

    for (let i = 0; i < configElements.length; i++) {
        try {
            let data = JSON.parse(configElements[0].textContent || '');

            config = { ...config, ...data };
        }
        catch {
        }
    }

    return config;
}
